import React, { useState, useEffect } from "react";
import { Modal, Dropdown } from "react-bootstrap";
import api from "services/api";
// import ls from "services/ls";
import { __ } from "services/Translator";

export default function CMSModal(props) {
  const [pageContent, setPageContent] = useState("");
  const [animationStarts, setAnimationStarts] = useState(false);
  const [loading, setLoading] = useState(true);

  const getResults = async () => {
    // props.setSpinner(true);
    setLoading(true);
    var response = await api.get("/get-content-page", {
      page_uid: props.openCMSModalTab,
    });
    if (response.status === 200) {
      // props.setSpinner(false);
      setLoading(false);
      setPageContent(response.data.content_data);
      setAnimationStarts(true);
      setTimeout(function () {
        setAnimationStarts(false);
      }, 300);
    } else {
      props.setSpinner(false);
      props.showAlert(null, response.data.message, true);
    }
  };

  useEffect(() => {
    getResults();
  }, [props.openCMSModalTab]);

  const renderHTML = (rawHTML: string) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });
  const closeLegalModal = () => {
    props.setOpenCMSModal(false);
    setPageContent("");
  };

  return (
    <>
      <Modal
        className="main_popup"
        show={props.openCMSModal}
        onHide={closeLegalModal}
        size="xl"
        centered
      >
        <Modal.Body>
          <div className="modalHeader">
            <div className="logo">
              <img
                src={require("../assets/images/new-landing/logo.png").default}
                alt="Card-Icon"
              />
            </div>
            <div onClick={closeLegalModal} className="close_button" closeButton>
              <i className="far fa-times"></i>
            </div>
          </div>
          <div className="legal_area">
            <div className="legal_heading padding_top_15">
              {!props.isMobileDevice && (
                <div className="tab_heading">
                  <div
                    onClick={() => props.setOpenCMSModalTab("careers")}
                    className={
                      "items " +
                      (props.openCMSModalTab === "careers" ? "active " : " ") +
                      props.landingType
                    }
                  >
                    <span
                      className={
                        props.openCMSModalTab === "careers"
                          ? "indicate show"
                          : "indicate"
                      }
                    ></span>
                    {__("Careers")}
                  </div>

                  <div
                    onClick={() =>
                      props.setOpenCMSModalTab("investor_relation")
                    }
                    className={
                      "items " +
                      (props.openCMSModalTab === "investor_relation"
                        ? "active "
                        : " ") +
                      props.landingType
                    }
                  >
                    <span
                      className={
                        props.openCMSModalTab === "investor_relation"
                          ? "indicate show"
                          : "indicate"
                      }
                    ></span>
                    {__("Investor relation")}
                  </div>
                  <div
                    onClick={() => props.setOpenCMSModalTab("about_us")}
                    className={
                      "items " +
                      (props.openCMSModalTab === "about_us" ? "active " : " ") +
                      props.landingType
                    }
                  >
                    <span
                      className={
                        props.openCMSModalTab === "about_us"
                          ? "indicate show"
                          : "indicate"
                      }
                    ></span>
                    {__("About Joker Casino")}
                  </div>

                  <div
                    onClick={() => props.setOpenCMSModalTab("terms_conditions")}
                    className={
                      "items " +
                      (props.openCMSModalTab === "terms_conditions"
                        ? "active "
                        : " ") +
                      props.landingType
                    }
                  >
                    <span
                      className={
                        props.openCMSModalTab === "terms_conditions"
                          ? "indicate show"
                          : "indicate"
                      }
                    ></span>
                    {__("Terms & conditions")}
                  </div>

                  <div
                    onClick={() => props.setOpenCMSModalTab("privacy_policy")}
                    className={
                      "items " +
                      (props.openCMSModalTab === "privacy_policy"
                        ? "active "
                        : " ") +
                      props.landingType
                    }
                  >
                    <span
                      className={
                        props.openCMSModalTab === "privacy_policy"
                          ? "indicate show"
                          : "indicate"
                      }
                    ></span>
                    {__("Privacy Policy")}
                  </div>

                  <div
                    onClick={() => props.setOpenCMSModalTab("aml_policy")}
                    className={
                      "items " +
                      (props.openCMSModalTab === "aml_policy"
                        ? "active "
                        : " ") +
                      props.landingType
                    }
                  >
                    <span
                      className={
                        props.openCMSModalTab === "aml_policy"
                          ? "indicate show"
                          : "indicate"
                      }
                    ></span>
                    {__("AML Policy")}
                  </div>

                  <div
                    onClick={() => props.setOpenCMSModalTab("returns_policy")}
                    className={
                      "items " +
                      (props.openCMSModalTab === "returns_policy"
                        ? "active "
                        : " ") +
                      props.landingType
                    }
                  >
                    <span
                      className={
                        props.openCMSModalTab === "returns_policy"
                          ? "indicate show"
                          : "indicate"
                      }
                    ></span>
                    {__("Returns Policy")}
                  </div>

                  <div
                    onClick={() =>
                      props.setOpenCMSModalTab("responsible_gaming")
                    }
                    className={
                      "items " +
                      (props.openCMSModalTab === "responsible_gaming"
                        ? "active "
                        : " ") +
                      props.landingType
                    }
                  >
                    <span
                      className={
                        props.openCMSModalTab === "responsible_gaming"
                          ? "indicate show"
                          : "indicate"
                      }
                    ></span>
                    {__("Responsible Gaming")}
                  </div>
                </div>
              )}
              {props.isMobileDevice && (
                <Dropdown data-bs-theme="dark">
                  <Dropdown.Toggle
                    id="dropdown-button-dark-example1"
                    variant="secondary"
                  >
                    {props.openCMSModalTab == "investor_relation"
                      ? "Investor Relation"
                      : props.openCMSModalTab == "about_us"
                      ? "About Us"
                      : props.openCMSModalTab == "terms_conditions"
                      ? "Terms & Conditions"
                      : props.openCMSModalTab == "privacy_policy"
                      ? "Privacy Policy"
                      : props.openCMSModalTab == "aml_policy"
                      ? "AML Policy"
                      : props.openCMSModalTab == "returns_policy"
                      ? "Returns Policy"
                      : props.openCMSModalTab == "responsible_gaming"
                      ? "Responsible Gaming"
                      : props.openCMSModalTab}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>
                      <div
                        onClick={() => props.setOpenCMSModalTab("careers")}
                        className={
                          "items " +
                          (props.openCMSModalTab === "careers"
                            ? "active "
                            : " ") +
                          props.landingType
                        }
                      >
                        <span
                          className={
                            props.openCMSModalTab === "careers"
                              ? "indicate show"
                              : "indicate"
                          }
                        ></span>
                        {__("Careers")}
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div
                        onClick={() =>
                          props.setOpenCMSModalTab("investor_relation")
                        }
                        className={
                          "items " +
                          (props.openCMSModalTab === "investor_relation"
                            ? "active "
                            : " ") +
                          props.landingType
                        }
                      >
                        <span
                          className={
                            props.openCMSModalTab === "investor_relation"
                              ? "indicate show"
                              : "indicate"
                          }
                        ></span>
                        {__("Investor relation")}
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div
                        onClick={() => props.setOpenCMSModalTab("about_us")}
                        className={
                          "items " +
                          (props.openCMSModalTab === "about_us"
                            ? "active "
                            : " ") +
                          props.landingType
                        }
                      >
                        <span
                          className={
                            props.openCMSModalTab === "about_us"
                              ? "indicate show"
                              : "indicate"
                          }
                        ></span>
                        {__("About Joker Casino")}
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div
                        onClick={() =>
                          props.setOpenCMSModalTab("terms_conditions")
                        }
                        className={
                          "items " +
                          (props.openCMSModalTab === "terms_conditions"
                            ? "active "
                            : " ") +
                          props.landingType
                        }
                      >
                        <span
                          className={
                            props.openCMSModalTab === "terms_conditions"
                              ? "indicate show"
                              : "indicate"
                          }
                        ></span>
                        {__("Terms & conditions")}
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div
                        onClick={() =>
                          props.setOpenCMSModalTab("privacy_policy")
                        }
                        className={
                          "items " +
                          (props.openCMSModalTab === "privacy_policy"
                            ? "active "
                            : " ") +
                          props.landingType
                        }
                      >
                        <span
                          className={
                            props.openCMSModalTab === "privacy_policy"
                              ? "indicate show"
                              : "indicate"
                          }
                        ></span>
                        {__("Privacy Policy")}
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div
                        onClick={() => props.setOpenCMSModalTab("aml_policy")}
                        className={
                          "items " +
                          (props.openCMSModalTab === "aml_policy"
                            ? "active "
                            : " ") +
                          props.landingType
                        }
                      >
                        <span
                          className={
                            props.openCMSModalTab === "aml_policy"
                              ? "indicate show"
                              : "indicate"
                          }
                        ></span>
                        {__("AML Policy")}
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div
                        onClick={() =>
                          props.setOpenCMSModalTab("returns_policy")
                        }
                        className={
                          "items " +
                          (props.openCMSModalTab === "returns_policy"
                            ? "active "
                            : " ") +
                          props.landingType
                        }
                      >
                        <span
                          className={
                            props.openCMSModalTab === "returns_policy"
                              ? "indicate show"
                              : "indicate"
                          }
                        ></span>
                        {__("Returns Policy")}
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div
                        onClick={() =>
                          props.setOpenCMSModalTab("responsible_gaming")
                        }
                        className={
                          "items " +
                          (props.openCMSModalTab === "responsible_gaming"
                            ? "active "
                            : " ") +
                          props.landingType
                        }
                      >
                        <span
                          className={
                            props.openCMSModalTab === "responsible_gaming"
                              ? "indicate show"
                              : "indicate"
                          }
                        ></span>
                        {__("Responsible Gaming")}
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
            <br />
            {/* <div className="badge"> {__("Welcome")}</div> */}
            <div className="row">
              <div className="col-md-12 col-lg-5">
                <div className="legal_img">
                  <img
                    alt="Legal image"
                    src="https://chimpbytes.imgix.net/legal-popup-bg.png?&dpr=1&format=auto&auto=format&q=75&w=582&h=630&max-age=2629056"
                  />
                </div>
              </div>
              <div className="col-md-12 col-lg-7">
                <div
                  className={
                    "legal_text_area " +
                    (animationStarts ? "slideUpAnimation " : "")
                  }
                >
                  {/* <div className="legal_heading">
                    {pageContent && pageContent?.page_title}
                  </div> */}
                  <div
                    className={
                      "legal_description " +
                      props.landingType +
                      (loading ? " loading" : "")
                    }
                  >
                    {loading ? (
                      <>
                        <div className="loader-area">
                          <div class="lds-ellipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="paragraph">
                          {pageContent && renderHTML(pageContent?.content)}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
